import * as React from 'react';
import { Link, useLocation, matchPath, generatePath } from 'react-router-dom';
import { useRegion } from 'common/hooks/region';

import { isPageSupported, Page } from '../../../../constants/pages';
import { User } from '../../../../types/User';
import { DisabledMenuItem } from './DisabledMenuItem';

interface Props {
  page: Page;
  user: User | null;
}

export const MenuItem: React.FC<Props> = (props) => {
  const { page, user } = props;
  const { title, isTabShown, children } = page;

  const location = useLocation();
  const region = useRegion();

  const to = generatePath(page.path, { region: region.route });
  const disabled = !isPageSupported(page, region);
  const active =
    !!matchPath(page.path, location.pathname) ||
    (children && children.some((c) => matchPath(c.path, location.pathname)));
  if (!user || (isTabShown && !isTabShown(user))) return null;

  if (disabled) {
    return <DisabledMenuItem page={page} active={active} />;
  }

  return (
    <Link key={title} to={to}>
      <h4
        className={`py-1 px-4 rounded-md text-blue-300 font-semibold ${
          active ? 'text-white' : 'text-blue-400'
        } hover:bg-darkblue-900`}
      >
        {title}
      </h4>
    </Link>
  );
};
MenuItem.displayName = 'DesktopNav.MenuItem';
